/* "Fliegt in den Warenkorb"-Animation (Harald 2026-09-24). Klont das Produktbild und
   animiert es zum Warenkorb-Icon im Header, sobald ein Produkt-Formular (PDP oder
   Quick-Add-Modal, beides <product-form><form>) abgeschickt wird. Optimistisch direkt
   beim Absenden ausgeloest (nicht erst nach der Server-Antwort) -- fuehlt sich schneller
   an, der Kauf-Button ist bei ausverkauften Varianten ohnehin deaktiviert/versteckt. */
(function () {
  function getCartIcon() {
    return document.getElementById('cart-icon-bubble');
  }

  function findSourceImage(form) {
    var card = form.closest('.card, .card-wrapper, quick-add-modal');
    if (card) {
      var cardImg = card.querySelector('img');
      if (cardImg) return cardImg;
    }
    // PDP-Hauptbild -- erst NACH der Karten-Suche pruefen, sonst wuerde auf einer Kollektions-
    // seite mit Quick-Add versehentlich ein ganz anderes, evtl. unsichtbares PDP-Bild
    // (z.B. aus einem verwandten Produkte-Slider) erwischt.
    var mediaImg = document.querySelector('.product__media-wrapper img, .product-media-container img');
    if (mediaImg) return mediaImg;
    return null;
  }

  function fly(sourceImg) {
    var cartIcon = getCartIcon();
    if (!cartIcon || !sourceImg) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var startRect = sourceImg.getBoundingClientRect();
    if (startRect.width === 0 || startRect.height === 0) return;
    var endRect = cartIcon.getBoundingClientRect();

    var clone = sourceImg.cloneNode(true);
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.className = 'cart-fly-clone';
    clone.style.left = startRect.left + 'px';
    clone.style.top = startRect.top + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    document.body.appendChild(clone);

    var endX = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    var endY = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);
    var targetSize = 46;
    var scale = targetSize / Math.max(startRect.width, startRect.height);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + endX + 'px, ' + endY + 'px) scale(' + scale + ')';
        clone.style.opacity = '0.1';
      });
    });

    var done = false;
    function cleanup() {
      if (done) return;
      done = true;
      clone.remove();
      // Nicht die urspruenglich eingelesene cartIcon-Referenz wiederverwenden: Dawn ersetzt
      // #cart-icon-bubble bei jedem Warenkorb-Update komplett (eigene "Section", siehe
      // cart-drawer.js getSectionsToRender) -- die alte Referenz waere bis hierhin oft schon
      // aus dem DOM entfernt, eine Klasse draufsetzen haette dann sichtbar keine Wirkung.
      var liveCartIcon = getCartIcon();
      if (!liveCartIcon) return;
      liveCartIcon.classList.add('cart-fly-bump');
      setTimeout(function () { liveCartIcon.classList.remove('cart-fly-bump'); }, 320);
    }
    clone.addEventListener('transitionend', cleanup, { once: true });
    setTimeout(cleanup, 900); // Sicherheitsnetz, falls transitionend mal nicht feuert
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('product-form') && form.getAttribute('action').indexOf('/cart/add') === -1) return;
      fly(findSourceImage(form));
    },
    true
  );
})();
